import React from "react";
import { Navigate } from "react-router-dom";
import { isWebAuthEnabled } from "../config/webAuth";

const WebAuthGate = ({ children }) => {
  if (!isWebAuthEnabled()) {
    return <Navigate to="/" replace />;
  }
  return children;
};

export default WebAuthGate;
